<template>
  <Splide :options="{ type: 'loop', perPage: 3, perMove: 1,  trimSpace  : false, padding: '5rem', gap: '2rem', autoplay: true }">
    <SplideSlide>
      <img src="https://res.cloudinary.com/dsjszihdo/image/upload/v1633702384/yygza6ynkrmqlriaagp6.jpg" alt="Sample 1">
    </SplideSlide>
    <SplideSlide>
      <img src="https://res.cloudinary.com/dsjszihdo/image/upload/v1628318230/kyeksenlmklprj36qbzn.jpg" alt="Sample 2">
    </SplideSlide>
  </Splide>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/splide.min.css'

export default {
  name: 'gl-slider',
  version: '0.0.1',
  props: {}, // props
  components: {
    Splide,
    SplideSlide
  }, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      formData: {}
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style lang="scss" scoped>
</style>
